import { gql } from "urql";

export const PRODUCT_GEN_SKU = gql`
  mutation productGenSku($productTypeKey: String!) {
    productGenSku(productTypeKey: $productTypeKey) {
      data
    }
  }
`;

export const AI_DESCRIPTION_BY_IMAGE = gql`
  mutation AiDescriptionByImage(
    $guid: String
    $file: File
    $mediaId: Int
    $useGpt: Boolean
    $language: String
  ) {
    aiDescriptionByImage(
      guid: $guid
      file: $file
      mediaId: $mediaId
      useGpt: $useGpt
      language: $language
    ) {
      captureDescription
      gptDescription1
      gptDescription2
      gptDescription3
      jewelryType
      productTitle
    }
  }
`;

export const MEDIA_SET_SKU = gql`
  mutation MediaSetSku($ids: [Int]!, $sku: String!) {
    mediaSetSku(ids: $ids, sku: $sku) {
      data
    }
  }
`;

export const AI_RECOGNITION = gql`
  mutation AiRecognition(
    $guid: String
    $mediaId: Int
    $language: String
    $type: String
    $cacheFirst: Boolean
  ) {
    aiRecognition(
      guid: $guid
      mediaId: $mediaId
      generateTitle: true
      generateDescription: true
      productTypeRecognition: true
      extendedGemstoneRecognition: true
      recognizeAnyPendantNecklaceAsPendant: false
      language: $language
      userDefinedMainStoneType: $type
      cacheFirst: $cacheFirst
    ) {
      title
      description
      recognition {
        type
        subType
        material
        mainGemstone
        mainDiamond
      }
    }
  }
`;

export const MEDIA_INFO = gql`
  query MediaInfo($id: Int) {
    mediaInfo(id: $id) {
      file {
        filename
        original
        small
      }
      id
      productType
      productTypeId
      guid
      type
      userId
      size
      sku
      productId
      status
    }
  }
`;

export const PRODUCT_TYPE_LIST = gql`
  query ProductTypeList($version: String) {
    productTypeList(version: $version) {
      data {
        id
        name
        description
        kind
        userId
        mainTypeKey
        key
        allowSubkey
        translations
        deactivated
      }
    }
  }
`;

export const AI_RECOGNITION_TYPE = gql`
  mutation AiRecognition($file: File, $language: String) {
    aiRecognition(
      file: $file
      generateTitle: true
      generateDescription: true
      productTypeRecognition: true
      extendedGemstoneRecognition: true
      language: $language
    ) {
      title
      description
      recognition {
        type
        subType
      }
    }
  }
`;
